// auth
import ContentFormatXX from '../content/webz/content-format-xx';
import WebbDividerSmall from '../content/webx/webb-divider-sm';
import WebbDividerMedium from '../content/webx/webb-divider-md';

import AuthNextModule from '../content/auth/auth-next';


export default function AuthNext() {
  
  return (
    <ContentFormatXX 
      head = {'Account Access'}
      home = {`/`}
      link = {`/`}
      form = {'mini'}
      data = {
        <>
          <WebbDividerMedium />
          <AuthNextModule />
          
        </>
        
      }  
    /> 
  )
}